export type AdminTransferRequest = { email: string; value: number }

export type AdminTransferResponse = {
  pixUrl: string | null
  pixQrCode: string | null
}

export type AdminTransferCalculatedValue = {
  value: number
}

export interface GetAdminCalculatedValueRequest {
  tenantId: string
}

export interface GetAdminTransferByTenantIdRequest {
  tenantId: string
}

export enum AdminTransferStatus {
  PENDING = 1,
  PROCESSING = 2,
  PAID = 3,
  FAILED = 4,
  CANCELED = 5,
}

export type AdminTransferItem = {
  id: string
  value: number
  status: AdminTransferStatus
  statusDescription: string
  userName: string
  createdDate: Date
  pixQrUrl: string | null
  pixQrCode: string | null
}
